import { useTranslation } from "react-i18next";
import { Address } from "../../../models/Address";
import { ConfirmationModal } from "../../ConfirmationModal";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        address?: Address;
    };
    onClose: () => void;
    setMainAddress: (address: Address) => void
}

export const SetClientMainAddressModal: React.FC<Props> = ({
    info,
    onClose,
    setMainAddress
}) => {

    const { t } = useTranslation();

    const onSetMainAddress = () => {
        setMainAddress(info.address!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("SET_MAIN_ADDRESS")}
            isDeleteConfirm={false}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("SET_MAIN_ADDRESS"), icon: <CheckIcon />, onClick: onSetMainAddress }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('SET_MAIN_ADDRESS_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}